<template>
  <div id="rsji-actions">
    <div class="router" :style="routerStyle">
      <router-view 
        :actions="actions" 
        :filters="filters"
        @heightChanged="height => routerHeight = height"
      />
    </div>

    <FilterSection :actions="actions" :filters="filters" :page="page" :prefilter="prefilter" />
  </div>
</template>

<script>
import FilterSection from "@/components/FilterSection.vue";

export default {
  props: {
    actions: Array,
    filters: Object,
  },
  data() {
    return {
      page: 1,
      prefilter: '',
      isAction: false,
      routerHeight: 0
    }
  },
  computed: {
    routerStyle() {
      let height = this.routerHeight + 'px'

      return `height:${height}; max-height:${height};`
    }
  },
  components: {
    FilterSection,
  },
  watch: {
    $route(to) {
      // console.log('to: ', to, 'from: ', from)
      let params = to.params

      this.page = params.page || 1
      this.prefilter = params.prefilter || ''
    }
  },
};
</script>

<style lang="scss">
  #rsji-actions {
    @media(max-width: 767px) {
      padding: 0px 15px;
    }
  }  

  .CardContainerComponent {
    display: none;

    .home &,
    .TopicFilterComponent & {
      display: block;
    }
  }
  .router {
    transition: all .3s ease-in-out;
    height: 0px;
    max-height: 0px;
    overflow: hidden;
  }

  // Fix for footnote spacing
  .VuejsSPAComponent + .MainColumnXHTMLCopyComponent.colorBlock {
      padding: 0;
      border: 0;
      margin: 0;

      a {
        font-weight:bold;
      }   
  }

</style>
